import React, { useContext } from 'react';
import { Button, useScreenClass } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import useSiteData from '../../hooks/useSiteData';
import { SourcePageContext } from '../contexts/SourcePageContext';
import { trackManageTextAlertsClicked } from '../../apis/newRelic/smsHandlingNewRelicTrackingApi';
import { OrderDetailsContext } from '../contexts/OrderDetailsContext';

export const ManageSmsSubscriptionButton = () => {
  const { order, setIsSmsSubscriptionModalOpen } =
    useContext(OrderDetailsContext);
  const [smsManagementMessages] = useTranslations(['smsManagementMessages']);

  const { vistacartTenant } = useSiteData();
  const { sourcePage } = useContext(SourcePageContext);
  const screenClass = useScreenClass();

  const handleManageClicked = () => {
    const trackingData = {
      orderNumber: order?.orderNumber,
      vistacartTenant,
      page: sourcePage,
    };
    if (setIsSmsSubscriptionModalOpen) {
      setIsSmsSubscriptionModalOpen(true);
    }
    trackManageTextAlertsClicked(order?.shopperId, trackingData);
  };

  return (
    <Button
      width={['xs', 'sm'].includes(screenClass) ? 'full-width' : 'standard'}
      onClick={() => handleManageClicked()}
    >
      {smsManagementMessages.manageAlertsTitle}
    </Button>
  );
};
